import { useState } from 'react';
import { PrinterIcon } from '@ui/kit/icons';
import { UniversalContextMenuButton } from '../molecule.contextmenu.js';
import { jsx } from 'react/jsx-runtime';

function PrintButton(props) {
  const [isPending, setPending] = useState(false);
  const handleClick = async () => {
    try {
      setPending(true);
      await props.onClick();
    } finally {
      setPending(false);
    }
  };
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "button",
    layout: props.layout,
    label: "Print",
    onClick: handleClick,
    async: !isPending ? undefined : {
      type: "download",
      progress: 0
    },
    icon: /*#__PURE__*/jsx(PrinterIcon, {
      height: 20
    })
  });
}

export { PrintButton };
//# sourceMappingURL=button.js.map
